import React from "react";
import {
  FormControl,
  Container,
  Select,
  MenuItem,
  InputLabel,
  Typography,
  Box,
  Button,
} from "@mui/material";

export default function Inputs({
  setSelectedPairing,
  selectedPairing,
  datasetTimePairings,
  setStageIdentified,
  stageIdentified,
  stageList,
  setCountry,
  country,
  countryList,
  setIsMulticenter,
  isMulticenter,
  multicenterList,
  setSelectedEnrollment,
  selectedEnrollment,
  enrollmentList,
  setSelectedPhase,
  selectedPhase,
  phaseList,
  registryList,
  selectedRegistry,
  setSelectedRegistry,
  handleTabChange,
  currentTab,
  tabs,
}) {
  return (
    <>
      <Container
        sx={{
          padding: 1,
          margin: 1,
          display: "flex",
          flexDirection: "column",
          maxWidth: "md",
          minWidth: "sm",
          alignSelf: "center",
        }}
        class="inputs"
      >
        <Container class="text-box" fullWidth>
          <Typography
            fontWeight={"bold"}
            sx={{ marginBottom: 1, fontSize: 20, marginTop: 1 }}
          >
            What counts as timely reporting of results?
          </Typography>
        </Container>
        <FormControl fullWidth>
          <InputLabel
            id="time-label"
            sx={{ fontSize: 16, fontWeight: "bold", color: "#222" }}
          >
            Published within
          </InputLabel>
          <Select
            labelId="time-label"
            sx={{ marginBottom: 1 }}
            onChange={(e) => {
              setSelectedPairing(e.target.value);
            }}
            label="Published within"
            value={selectedPairing}
          >
            {datasetTimePairings.map((pairing) => (
              <MenuItem value={pairing}>{pairing.threshold.label}</MenuItem>
            ))}
          </Select>
        </FormControl>

        <FormControl fullWidth>
          <InputLabel
            id="stage-label"
            sx={{ fontSize: 16, fontWeight: "bold", color: "#222" }}
          >
            Stage identified
          </InputLabel>
          <Select
            labelId="stage-label"
            sx={{ marginBottom: 1 }}
            onChange={(e) => {
              setStageIdentified(e.target.value);
            }}
            label="Stage Identified"
            value={stageIdentified}
          >
            {stageList.map((stage) => (
              <MenuItem value={stage}>{stage.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Container class="text-box" fullWidth>
          <Typography
            fontWeight={"bold"}
            sx={{ marginBottom: 1, fontSize: 20 }}
          >
            Sub-group filtering
          </Typography>
        </Container>

        <FormControl fullWidth>
          <InputLabel
            id="country-label"
            sx={{ fontSize: 16, fontWeight: "bold", color: "#222" }}
          >
            Country
          </InputLabel>
          <Select
            labelId="country-label"
            sx={{ marginBottom: 1 }}
            onChange={(e) => {
              setCountry(e.target.value);
            }}
            label="Country"
            value={country}
          >
            {countryList.map((country) => (
              <MenuItem value={country}>{country}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel
            id="multicenter-label"
            sx={{ fontSize: 16, fontWeight: "bold", color: "#222" }}
          >
            Multicenter
          </InputLabel>
          <Select
            labelId="multicenter-label"
            sx={{ marginBottom: 1 }}
            onChange={(e) => {
              setIsMulticenter(e.target.value);
            }}
            label="Multicenter"
            value={isMulticenter}
          >
            {multicenterList.map((isMulticenter) => (
              <MenuItem value={isMulticenter}>{isMulticenter}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel
            id="enrollment-label"
            sx={{ fontSize: 16, fontWeight: "bold", color: "#222" }}
          >
            Enrollment
          </InputLabel>
          <Select
            labelId="enrollment-label"
            sx={{ marginBottom: 1 }}
            onChange={(e) => {
              setSelectedEnrollment(e.target.value);
            }}
            label="Enrollment"
            value={selectedEnrollment}
          >
            {enrollmentList.map((enrollment) => (
              <MenuItem value={enrollment}>{enrollment.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel
            id="phase-label"
            sx={{ fontSize: 16, fontWeight: "bold", color: "#222" }}
          >
            Phase
          </InputLabel>
          <Select
            labelId="phase-label"
            sx={{ marginBottom: 1 }}
            onChange={(e) => {
              setSelectedPhase(e.target.value);
            }}
            label="Phase"
            value={selectedPhase}
          >
            {phaseList.map((phase) => (
              <MenuItem value={phase}>{phase}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <FormControl fullWidth>
          <InputLabel
            id="registry-label"
            sx={{ fontSize: 16, fontWeight: "bold", color: "#222" }}
          >
            Registry
          </InputLabel>
          <Select
            labelId="registry-label"
            sx={{ marginBottom: 1 }}
            onChange={(e) => {
              setSelectedRegistry(e.target.value);
            }}
            label="Registry"
            value={selectedRegistry}
          >
            {registryList.map((registry) => (
              <MenuItem value={registry}>{registry.label}</MenuItem>
            ))}
          </Select>
        </FormControl>
        <Container class="text-box" fullWidth>
          <Typography
            fontWeight={"bold"}
            sx={{ marginBottom: 1, fontSize: 20 }}
          >
            View data as
          </Typography>
        </Container>
        <Box>
          {tabs.map((item) => (
            <Button
              key={item}
              variant={currentTab === item ? "contained" : "outlined"}
              onClick={() => handleTabChange(item)}
              sx={{ marginLeft: 1, marginRight: 1, marginBottom: 2 }}
            >
              {item}
            </Button>
          ))}
        </Box>
      </Container>
    </>
  );
}
